import React from 'react';
import PropTypes from 'prop-types';

import BonusTitle from '@/components/atoms/BonusTitle';
import i18n from '@/translate/i18n';

import { ContentWrapper, InfoGrid, Wrapper } from './styles';
import { createRandomId } from '@/helpers/functions';
import TwTitle from '@/components/atoms/TwTitle';

function TransactionDetailsSummary({ data, bonus, hideTitle, customMargin }) {
  return (
    <Wrapper customMargin={customMargin}>
      {!hideTitle && (
        <TwTitle
          text={i18n.t('transactionDetailsSummary.title')}
          size="xl"
          font="arboriaBold"
          color="shadow-500"
          classList="text-center"
        />
      )}
      <ContentWrapper>
        {Object.entries(data).map(([key, value]) => {
          if (!value) {
            return null;
          }

          return key === 'bonus' ? (
            <InfoGrid key={createRandomId()} bonusType={bonus?.type}>
              <BonusTitle bonus={bonus} />
              <p className="text-left">
                <strong>{value}</strong>
              </p>
            </InfoGrid>
          ) : key.includes('youReceive') || key.includes('youTransferred') ? (
            <InfoGrid key={createRandomId()} divider>
              <p className="text-left">
                {i18n.t(`transactionDetailsSummary.${key}`)}
              </p>
              <p>{value}</p>
            </InfoGrid>
          ) : (
            <InfoGrid key={createRandomId()}>
              <p className="text-left">
                {i18n.t(`transactionDetailsSummary.${key}`)}
              </p>
              <p>{value}</p>
            </InfoGrid>
          );
        })}
      </ContentWrapper>
      <span />
    </Wrapper>
  );
}

TransactionDetailsSummary.propTypes = {
  bonus: PropTypes.shape,
  customMargin: PropTypes.string,
  data: PropTypes.shape,
  hideTitle: PropTypes.string,
};

export default TransactionDetailsSummary;
